import { jsx as _jsx } from "react/jsx-runtime";
import { ButtonDropdown, Input } from '@dossierhq/design';
import { useCallback } from 'react';
const EMPTY_ID = '  empty  ';
export function PatternSelector({ readOnly, value, schemaEditorState, onChange }) {
    const items = [
        { id: EMPTY_ID, label: _jsx("i", { children: "Not set" }) },
        ...schemaEditorState.patterns.map((pattern) => ({ id: pattern.name, label: pattern.name })),
    ];
    const handleItemClick = useCallback((item) => onChange(item.id === EMPTY_ID ? null : item.id), [onChange]);
    if (readOnly) {
        return (_jsx(Input, { readOnly: true, value: value ?? undefined, placeholder: !value ? 'Not set' : undefined }));
    }
    return (_jsx(ButtonDropdown, { items: items, renderItem: (item) => item.label, activeItemIds: [value ? value : EMPTY_ID], onItemClick: handleItemClick, children: value ?? _jsx("i", { children: "Not set" }) }));
}
//# sourceMappingURL=PatternSelector.js.map